

































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";
import { bus } from "../../main";
import { userService } from "../../_services";

@Component({
    components: {
        DetailsDialog: () => import("../Dialogs/DetailsDialog.vue")
    }
})
export default class ApprendistatoCreate extends Vue {
    @Prop({ default: false }) isOpen!: boolean;
    
    private annoScolastico: number;
    private annoSolare: number;
    private profiling: string;
    private idAllievo: number;
    private idAzienda: number;
    private tipoContratto: string;
    private dataInizio: string;
    private passaggioDaTirocinio: boolean;
    private dataInizioTirocinio: string;
    private dataFineTirocinio: string;
    private proroga: string;
    private dataFine: string;
    private cob: boolean;
    private tipoContrattoPostTirocinio: string;
    private note: string;

    private listaAllievi: any[];
    private listaAziende: any[];
    private anniScolastici: any[];

    private nomeAllievoSelezionato: string;
    private modalAllievo: boolean;
    private searchAllievoModal: string;
    private headersAllievi: any[];

    private nomeAziendaSelezionata: string;
    private modalAzienda: boolean;
    private searchAziendaModal: string;
    private headersAziende: any[];

    private searchAllievi: string;
    private searchAziende: string;
    private isLoadingAllievi: boolean;
    private isLoadingAziende: boolean;
    private isInitialLoading: boolean;
    private saving: boolean;

    // Menu date pickers
    private menuDataInizio: boolean;
    private menuDataInizioTirocinio: boolean;
    private menuDataFineTirocinio: boolean;
    private menuDataFine: boolean;

    // Validation rules
    private annoScolasticoRules: [boolean | string];
    private annoSolareRules: [boolean | string];
    private profilingRules: [boolean | string];
    private allievoRules: [boolean | string];
    private aziendaRules: [boolean | string];
    private tipoContrattoRules: [boolean | string];
    private dataInizioRules: [boolean | string];
    private dataInizioTirocinioRules: [boolean | string];
    private dataFineTirocinioRules: [boolean | string];
    private dataFineRules: [boolean | string];
    private prorogaRules: [boolean | string];
    private tipoContrattoPostTirocinioRules: [boolean | string];
    private noteRules: [boolean | string];

    constructor() {
        super();
        this.annoScolastico = 0;
        this.annoSolare = 0;
        this.profiling = "";
        this.idAllievo = 0;
        this.idAzienda = 0;
        this.tipoContratto = "";
        this.dataInizio = "";
        this.passaggioDaTirocinio = false;
        this.dataInizioTirocinio = "";
        this.dataFineTirocinio = "";
        this.proroga = "";
        this.dataFine = "";
        this.cob = false;
        this.tipoContrattoPostTirocinio = "";
        this.note = "";

        this.listaAllievi = [];
        this.listaAziende = [];
        this.anniScolastici = [];

        this.nomeAllievoSelezionato = "";
        this.modalAllievo = false;
        this.searchAllievoModal = "";
        this.headersAllievi = [
            { text: 'Nome', value: 'nomeUtente', sortable: true },
            { text: 'Cognome', value: 'cognomeUtente', sortable: true },
            { text: 'Codice Fiscale', value: 'cod', sortable: true },
            { text: 'Classe', value: 'classe', sortable: true },
            { text: "Dettagli", value: "details" }
        ];

        this.nomeAziendaSelezionata = "";
        this.modalAzienda = false;
        this.searchAziendaModal = "";
        this.headersAziende = [
            { text: "Azienda", value: "denominazioneAzienda" },
            { text: "Partita IVA", value: "pIva" },
            { text: "Comune", value: "comuneAzienda" },
            { text: "Dettagli", value: "details" }
        ];

        this.searchAllievi = "";
        this.searchAziende = "";
        this.isLoadingAllievi = false;
        this.isLoadingAziende = false;
        this.isInitialLoading = true;
        this.saving = false;

        this.menuDataInizio = false;
        this.menuDataInizioTirocinio = false;
        this.menuDataFineTirocinio = false;
        this.menuDataFine = false;

        this.annoScolasticoRules = [true];
        this.annoSolareRules = [true];
        this.profilingRules = [true];
        this.allievoRules = [true];
        this.aziendaRules = [true];
        this.tipoContrattoRules = [true];
        this.dataInizioRules = [true];
        this.dataInizioTirocinioRules = [true];
        this.dataFineTirocinioRules = [true];
        this.dataFineRules = [true];
        this.prorogaRules = [true];
        this.tipoContrattoPostTirocinioRules = [true];
        this.noteRules = [true];
    }

    // Date formatting methods
    formatDateToLocal(isoDate: string): string {
        if (!isoDate) return "";
        const date = new Date(isoDate);
        return date.toLocaleDateString('it-IT');
    }

    formatDateToISO(localDate: string): string {
        if (!localDate) return "";
        const parts = localDate.split('/');
        if (parts.length === 3) {
            // Assuming dd/mm/yyyy format
            const day = parts[0].padStart(2, '0');
            const month = parts[1].padStart(2, '0');
            const year = parts[2];
            return `${year}-${month}-${day}`;
        }
        return localDate; // Return as is if not in expected format
    }

    // Computed properties for local date display
    get dataInizioLocal(): string {
        return this.formatDateToLocal(this.dataInizio);
    }

    set dataInizioLocal(value: string) {
        this.dataInizio = this.formatDateToISO(value);
    }

    get dataInizioTirocinioLocal(): string {
        return this.formatDateToLocal(this.dataInizioTirocinio);
    }

    set dataInizioTirocinioLocal(value: string) {
        this.dataInizioTirocinio = this.formatDateToISO(value);
    }

    get dataFineTirocinioLocal(): string {
        return this.formatDateToLocal(this.dataFineTirocinio);
    }

    set dataFineTirocinioLocal(value: string) {
        this.dataFineTirocinio = this.formatDateToISO(value);
    }

    get dataFineLocal(): string {
        return this.formatDateToLocal(this.dataFine);
    }

    set dataFineLocal(value: string) {
        this.dataFine = this.formatDateToISO(value);
    }

    @Watch("isOpen")
    onDialogOpen(newVal: boolean, oldVal: boolean) {
        if (newVal && !oldVal) {
            this.startLoad()
        }
    }

    onAnnoScolasticoChange() {
        const annoSelezionato = this.anniScolastici.find(anno => anno.idAnnoScolastico === this.annoScolastico);
        if (annoSelezionato) {
            const match = annoSelezionato.nomeAnnoScolastico.match(/\/(\d{4})$/);
            if (match) {
                this.annoSolare = parseInt(match[1], 10);
            }
        }

        this.idAllievo = 0;
        this.nomeAllievoSelezionato = "";
        this.allievoRules = [true];

        this.loadAllievi();
    }

    validazioneAnnoScolastico() {
        const valid = this.annoScolastico > 0;

        if (valid) {
            this.annoScolasticoRules = [true];
        } else {
            this.annoScolasticoRules = ["Anno scolastico necessario"];
        }
    }

    validazioneProfiling() {
        var valid: boolean = false;
        if (this.profiling === "" || this.profiling === null) {
            this.profilingRules = [true];
        } else {
            if (this.profiling !== "" || this.profiling !== null) {
                valid = /^[0-9a-zA-Zìèéùòà!?;:,.\\'\x20]{2,25}$/.test(this.profiling);
            }
            if (valid) {
                this.profilingRules = [true];
            } else {
                this.profilingRules = ["Il Profiling non può superare i 25 caratteri e non deve contenere caratteri speciali"];
            }
        }
    }

    validazioneTipoContratto() {
        var valid: boolean = false;
        if (this.tipoContratto === "" || this.tipoContratto === null) {
            this.tipoContrattoRules = ["Tipo contratto necessario"];
        } else {
            if (this.tipoContratto !== "" || this.tipoContratto !== null) {
                valid = /^[0-9a-zA-Zìèéùòà!?;:,.\\'\x20]{2,255}$/.test(this.tipoContratto);
            }
            if (valid) {
                this.tipoContrattoRules = [true];
            } else {
                this.tipoContrattoRules = ["Tipo contratto non può superare i 255 caratteri e non deve contenere caratteri speciali"];
            }
        }
    }

    validazioneDataInizio() {
        const valid = this.dataInizio !== "";

        if (valid) {
            this.dataInizioRules = [true];
            // Se la data di fine è specificata, ricontrolla la validazione della data fine
            if (this.dataFine !== "") {
                this.validazioneDataFine();
            }
        } else {
            this.dataInizioRules = ["Data inizio necessaria"];
        }
    }

    validazioneDataFine() {
        // La data di fine è opzionale
        if (this.dataFine === "" || this.dataFine === null) {
            this.dataFineRules = [true];
            return;
        }

        // Se la data di fine è specificata, controlla che sia successiva alla data di inizio
        if (this.dataInizio === "" || this.dataInizio === null) {
            this.dataFineRules = ["Data inizio necessaria per validare la data fine"];
            return;
        }

        const dataInizio = new Date(this.dataInizio);
        const dataFine = new Date(this.dataFine);

        if (dataFine <= dataInizio) {
            this.dataFineRules = ["Data fine deve essere successiva alla data inizio"];
        } else {
            this.dataFineRules = [true];
        }
    }

    validazioneDataInizioTirocinio() {
        if (!this.passaggioDaTirocinio) {
            this.dataInizioTirocinioRules = [true];
            return;
        }

        const valid = this.dataInizioTirocinio !== "";

        if (valid) {
            this.dataInizioTirocinioRules = [true];
            // Se la data di fine tirocinio è specificata, ricontrolla la validazione
            if (this.dataFineTirocinio !== "") {
                this.validazioneDataFineTirocinio();
            }
        } else {
            this.dataInizioTirocinioRules = ["Data inizio tirocinio necessaria se passaggio da tirocinio"];
        }
    }

    validazioneDataFineTirocinio() {
        if (!this.passaggioDaTirocinio) {
            this.dataFineTirocinioRules = [true];
            return;
        }

        // Se passaggio da tirocinio è true, entrambe le date sono obbligatorie
        if (this.dataInizioTirocinio === "" || this.dataFineTirocinio === "") {
            if (this.dataInizioTirocinio === "") {
                this.dataInizioTirocinioRules = ["Data inizio tirocinio necessaria se passaggio da tirocinio"];
            }
            if (this.dataFineTirocinio === "") {
                this.dataFineTirocinioRules = ["Data fine tirocinio necessaria se passaggio da tirocinio"];
            }
            return;
        }

        // Controllo che la data di fine sia successiva alla data di inizio
        const dataInizio = new Date(this.dataInizioTirocinio);
        const dataFine = new Date(this.dataFineTirocinio);

        if (dataFine <= dataInizio) {
            this.dataFineTirocinioRules = ["Data fine tirocinio deve essere successiva alla data inizio"];
        } else {
            this.dataFineTirocinioRules = [true];
            this.dataInizioTirocinioRules = [true]; // Reset anche l'errore della data inizio se tutto è ok
        }
    }

    validazioneProroga() {
        var valid: boolean = false;
        if (this.proroga === "" || this.proroga === null) {
            this.prorogaRules = [true];
        } else {
            if (this.proroga !== "" || this.proroga !== null) {
                valid = /^[0-9a-zA-Zìèéùòà!?;:,.\\'\x20]{2,255}$/.test(this.proroga);
            }
            if (valid) {
                this.prorogaRules = [true];
            } else {
                this.prorogaRules = ["La Proroga non può superare i 255 caratteri e non deve contenere caratteri speciali"];
            }
        }
    }

    validazioneTipoContrattoPostTirocinio() {
        var valid: boolean = false;
        if (this.tipoContrattoPostTirocinio === "" || this.tipoContrattoPostTirocinio === null) {
            this.tipoContrattoPostTirocinioRules = [true];
        } else {
            if (this.tipoContrattoPostTirocinio !== "" || this.tipoContrattoPostTirocinio !== null) {
                valid = /^[0-9a-zA-Zìèéùòà!?;:,.\\'\x20]{2,255}$/.test(this.tipoContrattoPostTirocinio);
            }
            if (valid) {
                this.tipoContrattoPostTirocinioRules = [true];
            } else {
                this.tipoContrattoPostTirocinioRules = ["Il Tipo Contratto Post Tirocinio non può superare i 255 caratteri e non deve contenere caratteri speciali"];
            }
        }
    }

    validazioneNote() {
        var valid: boolean = false;
        if (this.note === "" || this.note === null) {
            this.noteRules = [true];
        } else {
            if (this.note !== "" || this.note !== null) {
                valid = /^[0-9a-zA-Zìèéùòà!?;:,.\\'\x20]{2,}$/.test(this.note);
            }
            if (valid) {
                this.noteRules = [true];
            } else {
                this.noteRules = ["Le Note non devono contenere caratteri speciali"];
            }
        }
    }

    validazioneAllievo() {
        const valid = this.idAllievo > 0;

        if (valid) {
            this.allievoRules = [true];
        } else {
            this.allievoRules = ["Allievo necessario"];
        }
    }

    validazioneAzienda() {
        const valid = this.idAzienda > 0;

        if (valid) {
            this.aziendaRules = [true];
        } else {
            this.aziendaRules = ["Azienda necessaria"];
        }
    }

    onPassaggioTirocinioChange() {
        if (!this.passaggioDaTirocinio) {
            this.dataInizioTirocinio = "";
            this.dataFineTirocinio = "";
            this.dataInizioTirocinioRules = [true];
            this.dataFineTirocinioRules = [true];
        }
    }

    clearDataInizio() {
        this.dataInizio = "";
        this.validazioneDataInizio();
    }

    clearDataInizioTirocinio() {
        this.dataInizioTirocinio = "";
        this.validazioneDataInizioTirocinio();
    }

    clearDataFineTirocinio() {
        this.dataFineTirocinio = "";
        this.validazioneDataFineTirocinio();
    }

    clearDataFine() {
        this.dataFine = "";
        this.validazioneDataFine();
    }

    openAllievoModal() {
        if (this.annoScolastico === 0) {
            bus.$emit("errorOperation", "Selezionare prima l'anno scolastico");
            return;
        }
        this.modalAllievo = true;
    }

    selectAllievo(allievo: any) {
        this.idAllievo = allievo.idUtente;
        this.nomeAllievoSelezionato = `${allievo.cognomeUtente} ${allievo.nomeUtente}`;
        this.allievoRules = [true];
        this.modalAllievo = false;
    }

    openAziendaModal() {
        this.modalAzienda = true;
    }

    selectAzienda(azienda: any) {
        this.idAzienda = azienda.idAzienda;
        this.nomeAziendaSelezionata = `${azienda.denominazioneAzienda}`;
        this.aziendaRules = [true];
        this.modalAzienda = false;
    }

    get listaAllieviFiltrati() {
        return this.listaAllievi;
    }

    get listaAziendeFiltrate() {
        return this.listaAziende;
    }

    get canSave() {
        return this.annoScolastico > 0 &&
            this.idAllievo > 0 &&
            this.idAzienda > 0 &&
            this.tipoContratto !== "" &&
            this.dataInizio !== "";
    }

    close() {
        this.annoScolastico = 0;
        this.annoSolare = 0;
        this.profiling = "";
        this.idAllievo = 0;
        this.nomeAllievoSelezionato = "";
        this.idAzienda = 0;
        this.nomeAziendaSelezionata = "";
        this.tipoContratto = "";
        this.dataInizio = "";
        this.passaggioDaTirocinio = false;
        this.dataInizioTirocinio = "";
        this.dataFineTirocinio = "";
        this.proroga = "";
        this.dataFine = "";
        this.cob = false;
        this.tipoContrattoPostTirocinio = "";
        this.note = "";

        this.modalAllievo = false;
        this.modalAzienda = false;
        this.isInitialLoading = false;
        this.saving = false;

        this.annoScolasticoRules = [true];
        this.annoSolareRules = [true];
        this.profilingRules = [true];
        this.allievoRules = [true];
        this.aziendaRules = [true];
        this.tipoContrattoRules = [true];
        this.dataInizioRules = [true];
        this.dataInizioTirocinioRules = [true];
        this.dataFineTirocinioRules = [true];
        this.dataFineRules = [true];
        this.prorogaRules = [true];
        this.tipoContrattoPostTirocinioRules = [true];
        this.noteRules = [true];

        bus.$emit("closeCreateDialog");
    }

    async executeValidation() {
        this.validazioneAnnoScolastico();
        this.validazioneProfiling();
        this.validazioneAllievo();
        this.validazioneAzienda();
        this.validazioneTipoContratto();
        this.validazioneDataInizio();
        this.validazioneDataInizioTirocinio();
        this.validazioneDataFineTirocinio();
        this.validazioneDataFine();
        this.validazioneProroga();
        this.validazioneTipoContrattoPostTirocinio();
        this.validazioneNote();
    }

    save() {
        this.saving = true;
        const instituteInfo = user.readInstituteInfo(this["$store"]);
        const apprendistato = {
            idIstituto: instituteInfo.id,
            idAnnoScolastico: this.annoScolastico,
            annoSolare: this.annoSolare,
            idAllievo: this.idAllievo,
            profiling: this.profiling || null,
            idAzienda: this.idAzienda,
            tipoContratto: this.tipoContratto,
            dataInizio: this.dataInizio,
            passaggioDaTirocinio: this.passaggioDaTirocinio,
            dataInizioTirocinio: this.passaggioDaTirocinio ? this.dataInizioTirocinio : null,
            dataFineTirocinio: this.passaggioDaTirocinio ? this.dataFineTirocinio : null,
            proroga: this.proroga || null,
            dataFine: this.dataFine || null,
            cob: this.cob,
            tipoContrattoPostTirocinio: this.tipoContrattoPostTirocinio || null,
            note: this.note || null
        }

        this.executeValidation().then(() => {
            if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
                user.dispatchCreateApprendistato(this["$store"], apprendistato)
                    .then(() => {
                        bus.$emit("successfullOperation", "Apprendistato creato con successo");
                        bus.$emit("loadApprendistati");
                        this.close();
                    })
                    .catch(error => {
                        if (error.response.status === 403) {
                            bus.$emit("errorOperation", error.response.statusText);
                            this["$router"].push("/login");
                        } else {
                            bus.$emit("errorOperation", error.response.statusText);
                        }
                        this.saving = false;
                    });
            } else {
                this.saving = false;
            }
        }).catch(() => {
            this.saving = false;
        });
    }

    async loadAllievi() {
        this.isLoadingAllievi = true;
        try {
            if (this.annoScolastico === 0) {
                this.listaAllievi = [];
                this.isLoadingAllievi = false;
                return;
            }

            var instituteInfo = user.readInstituteInfo(this["$store"]);
            var payload = {
                idIstituto: instituteInfo.id,
                annoScolastico: this.annoScolastico,
                isDiplomato: true,
                annoCorso: '5'
            };
            await data.dispatchStudentsList(this["$store"], payload)
                .then(result => {
                    this.listaAllievi = result;
                })
                .catch(error => {
                    bus.$emit("errorOperation", error.response.statusText);
                    bus.$emit("stopLoading");
                    this["$router"].push("/login");
                });
        } catch (error) {
            bus.$emit("errorOperation", "Errore nel caricamento della lista allievi");
        } finally {
            this.isLoadingAllievi = false;
        }
    }

    async loadAziende() {
        this.isLoadingAziende = true;

        try {
            var instituteInfo = user.readInstituteInfo(this["$store"])
            var payload = {
                idIstituto: instituteInfo.id
            }
            data.dispatchEnterprisesList(this["$store"], payload)
                .then(result => {
                    this.listaAziende = result;
                    bus.$emit("dataLoaded");
                })
                .catch(error => {
                    if (error.response.status === 401) {
                        bus.$emit("errorOperation", error.response.statusText);
                        this["$router"].push("/login");
                    } else {
                        bus.$emit("errorOperation", "Errore nel caricamento lista aziende");
                    }
                });
        } catch (error) {
            bus.$emit("errorOperation", "Errore nel caricamento della lista aziende");
        } finally {
            this.isLoadingAziende = false;
        }
    }

    async created() {
        await this.startLoad();
    }

    async startLoad(){
        this.isInitialLoading = true;

        try {
            await Promise.all([
                this.loadAnniScolastici(),
                this.loadAziende()
            ]);
        } catch (error) {
            bus.$emit("errorOperation", "Errore durante il caricamento iniziale dei dati");
        } finally {
            this.isInitialLoading = false;
        }
    }

    async loadAnniScolastici() {
        await data.dispatchAnniScolastici(this["$store"])
            .then(result => {
                this.anniScolastici = result;
            })
            .catch(error => {
                bus.$emit("errorOperation", "Errore nel caricamento degli anni scolastici");
            });
    }
}
